import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { Box } from '@material-ui/core'

import { useBaseContainer } from './BaseContainer.hooks'

const BaseContainer = forwardRef((props, ref) => {
	const [
		{ classes, className, children },
		{ handleLoad, handleTransitionEnd, handelAnimationEnd },
	] = useBaseContainer(props)

	return (
		<Box
			ref={ref}
			className={clsx(classes.root, className)}
			display="flex"
			flexDirection="column"
			onLoad={handleLoad}
			onTransitionEnd={handleTransitionEnd}
			onAnimationEnd={handelAnimationEnd}
		>
			{children}
		</Box>
	)
})

BaseContainer.propTypes = {
	className: PropTypes.string,
	minMarginTop: PropTypes.number,
	minMarginBottom: PropTypes.number,
	children: PropTypes.node,
}

export default BaseContainer
